var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStadt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0833 32.2858L25.1192 32.2464M39.4167 32.2858L39.4525 32.2464M25.0833 46.6192L25.1192 46.5797M39.4167 46.6192L39.4525 46.5797M25.0833 60.9525L25.1192 60.9131M39.4167 60.9525L39.4525 60.9131M53.75 75.25H12.9C12.3298 75.25 11.7829 75.0235 11.3797 74.6203C10.9765 74.2171 10.75 73.6702 10.75 73.1V20.0667C10.75 19.4965 10.9765 18.9496 11.3797 18.5464C11.7829 18.1432 12.3298 17.9167 12.9 17.9167H32.25V12.9C32.25 12.3298 32.4765 11.7829 32.8797 11.3797C33.2829 10.9765 33.8298 10.75 34.4 10.75H51.6C52.1702 10.75 52.7171 10.9765 53.1203 11.3797C53.5235 11.7829 53.75 12.3298 53.75 12.9V32.25M53.75 75.25H73.1C73.6702 75.25 74.2171 75.0235 74.6203 74.6203C75.0235 74.2171 75.25 73.6702 75.25 73.1V34.4C75.25 33.8298 75.0235 33.2829 74.6203 32.8797C74.2171 32.4765 73.6702 32.25 73.1 32.25H53.75M53.75 75.25V60.9167M53.75 32.25V46.5833M53.75 60.9167V46.5833M53.75 60.9167H60.9167M53.75 46.5833H60.9167",
    stroke: "currentColor",
    strokeWidth: 5.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStadt);
export default __webpack_public_path__ + "static/media/stadt.729fd8da42d3ee05408f522f16192e78.svg";
export { ForwardRef as ReactComponent };